/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Guest_TitleInputs */

const en_check_in_guest_title = /** @type {(inputs: Check_In_Guest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to start your reward journey`)
};

const es_check_in_guest_title = /** @type {(inputs: Check_In_Guest_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesion para comenzar tus recompensas`)
};

/**
* | output |
* | --- |
* | "Sign in to start your reward journey" |
*
* @param {Check_In_Guest_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_guest_title = /** @type {((inputs?: Check_In_Guest_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Guest_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_guest_title(inputs)
	return es_check_in_guest_title(inputs)
});